import { render, staticRenderFns } from "./cms-container.vue?vue&type=template&id=379b04fc&scoped=true"
import script from "./cms-container.vue?vue&type=script&lang=js"
export * from "./cms-container.vue?vue&type=script&lang=js"
import style0 from "./cms-container.vue?vue&type=style&index=0&id=379b04fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379b04fc",
  null
  
)

export default component.exports